import { render } from "./UserRegistrationForm.vue?vue&type=template&id=444d1b50&ts=true"
import script from "./UserRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./UserRegistrationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__